import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Sun } from 'lucide-react';
import './pages.css';
import PlantCard from '../components/ui/PlantCard';
import { EmptyState } from '../components/ui/States';
import Breadcrumbs from '../components/ui/Breadcrumbs';

export default function PlantsPage() {
  const { plants } = useOutletContext();
  const navigate = useNavigate();
  const safePlants = Array.isArray(plants) ? plants : [];

  return (
    <div className="page">
      <Breadcrumbs items={[{ label: 'Tableau de bord', to: '/' }, { label: 'Centrales' }]} />
      <div className="page-header">
        <h1><Sun size={22} className="icon-sun" /> Centrales</h1>
      </div>
      {safePlants.length === 0 ? (
        <EmptyState label="Aucune centrale accessible pour votre compte" />
      ) : (
        <div className="plants-grid">
          {safePlants.map((plant) => (
            <PlantCard key={plant.plant_id} plant={plant} onClick={() => navigate(`/plants/${plant.plant_id}`)} />
          ))}
        </div>
      )}
    </div>
  );
}
